import { MailWarning } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** Gmail filed this email in the rep's Spam folder when it arrived, so the rep likely never saw it. Shared by the
 *  Contact Command Center row and the contact timeline so both say it the same way. */
export function WentToSpamBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      data-testid="went-to-spam-badge"
      title="Gmail put this email in the rep's Spam folder, so they may never have seen it"
      className={cn(
        "rounded-full border-warning/50 bg-warning/15 px-2 py-0 text-xs font-medium text-warning",
        className,
      )}
    >
      <MailWarning className="mr-1 h-3 w-3" aria-hidden />
      Went to Spam
    </Badge>
  );
}
